export default "__VITE_ASSET__CDVsyfGA__"